import { render, staticRenderFns } from "./sdDetail.vue?vue&type=template&id=06e594a9&scoped=true"
import script from "./sdDetail.vue?vue&type=script&lang=js"
export * from "./sdDetail.vue?vue&type=script&lang=js"
import style0 from "./sdDetail.vue?vue&type=style&index=0&id=06e594a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e594a9",
  null
  
)

export default component.exports